import { FiCheckCircle, FiEdit, FiEye, FiRotateCcw } from "react-icons/fi"
import Button from "../../component/button/button"

type PreviewHeaderActionsProps = {
  isEditing: boolean
  submitting: boolean
  hasUnsavedChanges: boolean
  onEdit: () => void
  onPreview: () => void
  onReset: () => void
  onPublish: () => void
  onSaveDraft: () => void
}

const PreviewHeaderActions = ({
  isEditing,
  submitting,
  hasUnsavedChanges,
  onEdit,
  onPreview,
  onReset,
  onPublish,
  onSaveDraft,
}: PreviewHeaderActionsProps) => (
  <div className='question_preview_v2__header-actions'>
    {isEditing ? (
      <Button
        text='Preview'
        type='secondary'
        icon={<FiEye size={18} />}
        disabled={submitting}
        onClick={onPreview}
      />
    ) : (
      <Button
        text='Edit'
        type='secondary'
        icon={<FiEdit size={18} />}
        disabled={submitting}
        onClick={onEdit}
      />
    )}
    {hasUnsavedChanges && (
      <Button
        text='Reset changes'
        type='secondary'
        icon={<FiRotateCcw size={18} />}
        disabled={submitting}
        onClick={onReset}
      />
    )}
    <Button
      text={submitting ? "Saving…" : "Save as draft"}
      type='secondary'
      disabled={submitting}
      onClick={onSaveDraft}
    />
    <Button
      text={submitting ? "Publishing…" : "Publish"}
      type='primary'
      icon={<FiCheckCircle size={18} />}
      disabled={submitting}
      onClick={onPublish}
    />
  </div>
)

export default PreviewHeaderActions
